import Collaborators from "../../components/Collaborators";
import Container from "../../components/Container";
import ContainerDivider from "../../components/ContainerDivider";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import PublicNavbar from "../../components/PublicNavbar";
import React from "react";
import Spacer from "../../components/Spacer";
import SubscriptionForm from "../../components/SubscriptionForm/SubscriptionForm";
import SubscriptionSection from "../../components/SubscriptionSection";
import useCurrentUser from "../../hooks/useCurrentUser";

const NotFound = () => {
  const currentUser = useCurrentUser();

  return (
    <div className="NotFoundPage">
      {!currentUser ? <PublicNavbar /> : <Navbar />}
      <Container>
        <div className="flex flex-wrap my-16 lg:flex-no-wrap">
          <div className="w-full lg:w-1/2">
            <div className="text-lg font-medium">Page Not Found</div>
            <h1 className="my-4 text-6xl font-bold leading-none">404 Error</h1>
            <div className="my-4 text-xs text-gray-400">An error occurred.</div>
            <div className="max-w-sm text-base">
              We could not find the page you're looking.
            </div>
            <div className="max-w-sm mt-8">
              <SubscriptionForm
                title="Sign up to be notified about the event."
                buttonName="Notify Me"
              />
            </div>
          </div>
        </div>
      </Container>

      <Spacer>
        <ContainerDivider />
        <Collaborators />
      </Spacer>

      <SubscriptionSection />
      <Footer />
    </div>
  );
};

export default NotFound;
